export default __webpack_public_path__ + "7c9bd8db238bc6d3368a719d5ceb1e8e.png";